import { Strategy } from '../../types/models'

/**
 * Optimizer-control port settings a relay appliance strategy implies.
 *
 * The strategy chip is the only thing a customer sees; the port config is
 * what the device runs. These two used to be tied together only at the
 * moment the chip was clicked (`RelayAppliance.configTop/onSelectStrategy`),
 * so any later edit of the port — the installer-level "Plan by price"
 * switch, an older save, a hand-edited port — left an appliance showing AUTO
 * while the device ran PV_ONLY (C2C0730E, 2026-08-28: 9 sites fleet-wide).
 *
 * `pv_priority` is deliberately not derived here: it is owned by the
 * appliance's own `pv_priority` config and the solar self-consumption
 * switch, and many AUTO appliances legitimately run with `pv_priority: 0`.
 */
export function strategyPortConfig(strategy: Strategy | undefined): { enabled?: boolean, plan_by_price?: boolean } {
  switch (strategy) {
    case 'MANUAL':
    case 'CALENDAR':
      return { enabled: false }
    case 'AUTO':
    case 'AVOID_EXPENSIVE':
      return { enabled: true, plan_by_price: true }
    case 'PV_ONLY':
      return { enabled: true, plan_by_price: false }
    default:
      return {}
  }
}

/**
 * The strategy chip that matches a `plan_by_price` toggle, given whether the
 * appliance takes part in solar self-consumption. Inverse of
 * `strategyPortConfig` for the enabled strategies.
 */
export function strategyForPlanByPrice(planByPrice: boolean, pvPriority: number): Strategy {
  if (!planByPrice) return 'PV_ONLY'
  return pvPriority > 0 ? 'AUTO' : 'AVOID_EXPENSIVE'
}
